import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconDoAndDontBox12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconDoAndDontBox12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#DoAndDontBox12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M.116.116a.5.5 0 0 1 .707 0L1.94 1.233 3.057.116a.5.5 0 0 1 .707.707L2.647 1.94l1.117 1.117a.5.5 0 1 1-.707.707L1.94 2.647.823 3.764a.5.5 0 0 1-.707-.707L1.233 1.94.116.823a.5.5 0 0 1 0-.707M1 5.883V9.5A1.5 1.5 0 0 0 2.5 11h3.383v-1H2.5a.5.5 0 0 1-.5-.5V5.883zM5.883 2H9.5a.5.5 0 0 1 .5.5v3.383h1V2.5A1.5 1.5 0 0 0 9.5 1H5.883zm6.001 6.169a.5.5 0 0 1 0 .707l-2.677 2.677-.354.354-.353-.354-1.394-1.393a.5.5 0 0 1 .707-.707l1.04 1.04 2.324-2.324a.5.5 0 0 1 .707 0"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="DoAndDontBox12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconDoAndDontBox12);
